<template>
  <div>
    <div class="container-fluid page-head-wrap" v-if="apiLoading">
      <div class="container page-head text-center">
        <p class="mb-0"><i class="fa fa-spinner fa-pulse fa-fw" style="font-size: 14px; "></i> <trans-text i18nKey="ui['5_4_1'][101]"/></p>
      </div>
    </div>
    <div class="container">
      <div class="row">
         <page-content :event="event" :cart="cart" :totalCount="totalCount" :totalPrice="totalPrice"
                        :isShowCategoryPopover="isShowCategoryPopover" ref="pageContent" @refleshTotal="refleshTotal"
          @selectCategory="selectCategory" @toggleIsShowCategoryPopover="toggleIsShowCategoryPopover"
          ></page-content>
      </div>
    </div>
  </div>

</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import PageContent from 'page/partials/Order/Catalog/PageContent.vue'
  import Event from 'processor/Event'
  import Cart from 'processor/Cart'

  export default {
    name:"",
    components: {
      PageContent,
    },
    data () {
      return {
        totalCount:0,
        totalPrice:0,
        isShowCategoryPopover:false,
        event:{},
        cart:{},
        apiLoading:true,
      }
    },
    computed(){

    },
    beforeRouteLeave (to, from, next) {
      this.isShowCategoryPopover=false
      $(this.$refs.pageContent.$refs.zoomModal.$refs.modal).modal("hide")
      this.$nextTick(function () {
        next()
      });
    },
    mounted(){
      this.fetchEvent()
    },
    beforeRouteUpdate (to, from, next) {
//      this.fetchEvent()
      next()
    },
    methods:{
      refleshTotal(){
        app.make("axios").get(`v1/cart-total-price`,{})
          .then(({data}) =>{
            this.totalCount = data.count
            this.totalPrice = data.total_price
          })
          .catch(error => {
          })
      },
      selectCategory(){
        this.isShowCategoryPopover=false
      },
      toggleIsShowCategoryPopover(){
        this.isShowCategoryPopover = !this.isShowCategoryPopover
      },
      fetchEvent(){
        Event.getEvent({event_id: this.$route.params.event_id, with_photos: 1, with_categories: 1,by_catalog_page:1})
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByViewingEvent = res.apiErrorI18nKey
              return
            }
            this.event = res.data.event
            this.apiLoading=false
            this.$nextTick(()=> {
              setTimeout(()=>{
                this.$Lazyload.lazyLoadHandler()
              },50)
            })
          })
        Cart.cartPreparation()
          .then((res) => {
            if (res.status === "ng") {
              this.apiErrorI18nKeyByCart = res.apiErrorI18nKey
              return
            }
            this.cart = res.data.cart

            this.refleshTotal()
          })
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// Catalog.vue?94cecb96